
<component
  :is="as"
  :class="['tab', 'secondary-font', { active }]"
  v-bind="$attrs"
  v-on="$listeners"
>
  <slot />
</component>
